/**
 * /schedule: everything the player takes part in over the next month (live
 * first, grouped by day), then their leagues and tournaments in progress.
 * The dashboard shows only the next few; this page can grow freely.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GameLayout from '../layout/GameLayout';
import { apiClient } from '../../services/api/apiService';
import MySchedule from './MySchedule';

export const SCHEDULE_PAGE_DAYS = 31;

function SchedulePage({ token, onLogout }) {
  const navigate = useNavigate();
  const [schedule, setSchedule] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let live = true;
    apiClient.get('/users/me/schedule', { params: { days: SCHEDULE_PAGE_DAYS } })
      .then((r) => live && setSchedule(r.data?.data || { items: [], inProgress: [], days: SCHEDULE_PAGE_DAYS }))
      .catch(() => live && setError('Could not load your schedule. Try again in a moment.'));
    return () => { live = false; };
  }, []);

  return (
    <GameLayout token={token} onLogout={onLogout}>
      <div className="schedule-page" style={{ maxWidth: 720, margin: '0 auto', padding: '1rem 1rem calc(2rem + env(safe-area-inset-bottom, 0px))' }}>
        <button
          type="button"
          onClick={() => navigate('/dashboard')}
          style={{ background: 'none', border: 0, color: '#7dd3fc', cursor: 'pointer', padding: 0, marginBottom: '0.6rem', fontSize: '0.9rem' }}
        >
          ← Dashboard
        </button>
        <h1 style={{ color: '#fff', fontSize: '1.4rem', margin: '0 0 0.75rem' }}>My schedule</h1>
        {error && <p role="alert" style={{ color: '#fca5a5' }}>{error}</p>}
        {!error && !schedule && <p style={{ color: '#94a3b8' }}>Loading…</p>}
        {schedule && <MySchedule schedule={schedule} full />}
      </div>
    </GameLayout>
  );
}

export default SchedulePage;
